import { defineStore } from 'pinia';
import userApiService from '@/services/system.api.service';
import translationsApiService from '@/services/translations.api.service';
import { ITranslations, ITranslationsApi } from '@/types/translationsTypes';
import { IBreadcrumbItem } from '@/types/breadcrumbsTypes';
import { reactive } from 'vue';
import { CwxBackend } from '@/types/cwxBackend';

export const useAppStore = defineStore('app', {
  state: () => ({
    isAppHotReloading: false,
    isAppStarting: true,
    isAppDataFetching: true,
    isTranslationsFetched: false,
    isMobile: false,
    dir: '' as string,
    cultureCode: '' as string,
    systemSettings: {} as CwxBackend.ISystemSettingsDto,
    configuration: {} as CwxBackend.IConfigurationDto,
    cultureSettings: {} as CwxBackend.ICultureSettingsDto,
    translations: {} as ITranslations,
    breadcrumbs: reactive([]) as IBreadcrumbItem[],
    customCssSettings: '' as string,
    previouslyFocusedElement: null as HTMLElement | null,
  }),
  actions: {
    async fetchTranslations() {
      const translationsFromApi: ITranslationsApi =
        await translationsApiService.getTranslationsByLocationCode(this.cultureCode);

      this.translations = { ...translationsFromApi } as ITranslations;
      this.isTranslationsFetched = true;
    },
    async fetchSystemSettings() {
      this.systemSettings = await userApiService.getSystemSettings();
    },
    async fetchConfiguration() {
      this.configuration = await userApiService.getConfiguration();
    },
    async fetchCultureSettings() {
      this.cultureSettings = await userApiService.getCultureSettings();
      this.cultureCode = this.cultureSettings.currentCultureCode;
    },
    async fetchCustomCssSettings() {
      this.customCssSettings = await userApiService.getCustomCssSettings();
    },
    setBreadcrumbs(breadcrumbsItems: IBreadcrumbItem[]) {
      this.breadcrumbs = breadcrumbsItems;
    },
    getLocale() {
      return this?.cultureCode;
    },
    getLanguage() {
      return this?.cultureCode?.split('-')[0];
    },
  },
  getters: {
    isAppReady: (state): boolean => {
      return !state.isAppStarting && state.isTranslationsFetched;
    },
    mobileBreakpoint: (): number => {
      return 768;
    },
  },
});
